import { Link } from 'react-router-dom';
import { themeClasses, Button } from '@member-portal/ui';

interface MembersOnlyOverlayProps {
  title?: string;
  message?: string;
}

function MembersOnlyOverlay({
  title = 'Members Only',
  message = 'Log in or sign up to access this content.',
}: MembersOnlyOverlayProps) {
  return (
    <div className="absolute inset-0 backdrop-blur-md bg-white/30 flex items-center justify-center z-10">
      <div className="bg-white p-8 md:p-12 max-w-md mx-4 text-center shadow-lg border border-theme-border">
        <h2 className={`${themeClasses.title.h4} mb-4`}>
          {title}
        </h2>
        <p className={`${themeClasses.text.muted} mb-8`}>
          {message}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/login">
            <Button variant="secondary">
              Log in
            </Button>
          </Link>
          <Link to="/signup">
            <Button variant="primary">
              Advisor Sign Up
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default MembersOnlyOverlay;
